module.exports = __webpack_public_path__ + "static/media/cloud-drizzle.d1613178.svg";